import { ProcessingScreenProps } from '@packages/shared/core/quiz/entities';
import Header from '@packages/shared/core/common/components/layout/Header';
import ProcessingScreenLoaderList from './ProcessingScreenLoaderList';
import ProcessingScreenLoader from './ProcessingScreenLoader';
import styles from './ProcessingScreen.module.scss';

const ProcessingScreen = (props: ProcessingScreenProps) => {
  const { content, onFinished } = props;

  return (
    <>
      <div className={styles.background} />

      <div className={styles.container}>
        <Header className={styles.header} menuClassName={styles.menu} />

        <div className={styles.content}>
          <h2 className={styles.title}>{content.title}</h2>

          <div className={styles.loaderContainer}>
            <div className={styles.loaderBackground} />

            <ProcessingScreenLoader onFinished={onFinished} />
          </div>

          <ProcessingScreenLoaderList list={content.stages} />
        </div>
      </div>
    </>
  );
};

export default ProcessingScreen;
